import { Tool } from './Tool';

export class SelectTool extends Tool {
  public title = 'TOOLBAR_SELECT';

  public icon = 'icon-mouse1';
}

export const selectTool = new SelectTool();
